var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSportsEsports = function SvgSportsEsports(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "sports-esports_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sports-esports_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.53 18.5q-1.015 0-1.575-.72-.56-.718-.424-1.695L3.6 8.527q.196-1.317 1.164-2.172A3.34 3.34 0 0 1 7.05 5.5h9.9q1.317 0 2.285.855T20.4 8.527l1.07 7.558q.136.975-.425 1.696-.56.72-1.576.719-.429 0-.787-.144a2 2 0 0 1-.667-.452L15.611 15.5H8.388l-2.404 2.404a2 2 0 0 1-.666.452q-.359.144-.787.144m.4-1.65L7.78 14h8.44l2.85 2.85q.049.05.38.15.276 0 .437-.163.163-.162.113-.437l-1.1-7.7a1.92 1.92 0 0 0-.655-1.212A1.9 1.9 0 0 0 16.95 7h-9.9a1.9 1.9 0 0 0-1.295.487Q5.2 7.976 5.1 8.7L4 16.4q-.05.275.112.438A.6.6 0 0 0 4.55 17q.07 0 .38-.15m12.71-4.21a.87.87 0 0 0 .264-.64.87.87 0 0 0-.264-.64.87.87 0 0 0-.64-.264.87.87 0 0 0-.64.264.87.87 0 0 0-.264.64q0 .377.263.64.264.264.64.264a.87.87 0 0 0 .641-.264m-2-3a.87.87 0 0 0 .264-.64.87.87 0 0 0-.264-.64.87.87 0 0 0-.64-.264.87.87 0 0 0-.64.264.87.87 0 0 0-.264.64q0 .377.263.64.264.264.64.264a.87.87 0 0 0 .641-.264m-7.736 3.206h1.192v-1.75h1.75V9.904h-1.75v-1.75H7.904v1.75h-1.75v1.192h1.75z"
  }))));
};
export default SvgSportsEsports;